import React, { useEffect, useRef, useState } from "react";
import ReviewCard from "./reviewCard";
import styles from "./style.module.scss";

const ScrollingCards = ({ reviews, setAllReviewsScrolled, compact = false }) => {
  const [currReviews, setCurrReviews] = useState(reviews?.slice(0, 2));
  const [index, setIndex] = useState(0);
  const cardRef = useRef();
  useEffect(() => {
    const updateReviews = () => {
      if (!reviews || reviews?.length === 0) {
        setAllReviewsScrolled(true);
        return;
      }
      const nextIndex = index + 2 >= reviews?.length ? 0 : index + 2;
      setCurrReviews(reviews.slice(nextIndex, nextIndex + 2));
      setIndex(nextIndex);
      if (nextIndex === 0 && reviews?.length > 0) {
        setAllReviewsScrolled(true);
      }
    };
    // Scroll reviews for every 25 seconds
    const interval = setInterval(updateReviews, 24 * 1000);
    return () => clearInterval(interval);
  }, [reviews, index, setAllReviewsScrolled]);
  if (reviews?.length === 0) return <></>;
  const wrapperClass =
    reviews?.length > 2
      ? compact
        ? styles.cardsWrapperAnimateCompact
        : styles.cardsWrapperAnimate
      : compact
      ? styles.cardsWrapperCompact
      : styles.cardsWrapper;
  return (
    <div className={wrapperClass} ref={cardRef}>
      {currReviews?.map((review, reviewIndex) => {
        return (
          <div key={reviewIndex} className={styles.cardWrapper}>
            <ReviewCard review={review} />
          </div>
        );
      })}
    </div>
  );
};

export default ScrollingCards;
